// 路由验证
import router from './index.js'
import store from "../store/index.js"
import { islogin } from "../https/api/user/user.js"
import { loginvalidation } from "../https/api/admin/index.js"
import i18n from "../components/language/index.js"
import { MessageBox } from "element-ui"

//引入路由加载效果
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


const whiteList = ['index', 'about'];

//路由前置守卫
router.beforeEach((to, from, next) => {
    NProgress.start()
    const flog = localStorage.getItem('token')
        // console.log(flog, 3333)
    if (to.meta.islogin) { //判断用户是否登录
        islogin().then((res) => {
                if (res.code === 0) {
                    store.commit('changuinfor');
                    if (whiteList.indexOf(to.name) > -1) {
                        next();
                    } else {
                        MessageBox.alert(i18n.t('message.loginfirst'), i18n.t('message.btn.prompt'), {
                            confirmButtonText: i18n.t('message.btn.confirm'),
                            type: 'warning',
                            callback: action => {
                                router.push('/login');
                            }
                        });
                    }
                } else {
                    store.commit('changuinfor', res);
                    next();
                }
            }).catch(() => {})
            // console.log(flog, 2222)
    } else if (flog === "") {
        MessageBox.alert(i18n.t('message.loginfirst'), i18n.t('message.btn.prompt'), {
            confirmButtonText: i18n.t('message.btn.confirm'),
            type: 'warning',
            callback: action => {
                router.push('/login');
            }
        });
    } else if (to.meta.adminlogin) { //判断管理员登录
        loginvalidation().then((res) => {
            if (res.code === 0) {
                MessageBox.alert('please log in first', 'Prompt', {
                    confirmButtonText: "Confirm",
                    callback: action => {
                        router.push('/adminlogin/123123');
                    }
                });
            } else {
                store.commit('changadmininfor', res);
                next();
            }
        })
    } else {
        next();
    }
})


//路由后置守卫
router.afterEach((to, from) => {
    NProgress.done()
})


// WEBPACK FOOTER //
// ./src/router/verification.js